import React, { useState } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { CashoutType } from "@gp/hub";

import { Modal } from "@lib/modal";
import { ISOToDisplayCode} from "@utils";
import { Button } from "@components/buttons";
import { CashoutStore } from "@state/stores/my-bets/CashoutStore";
import { CashoutLocation } from "@utils/common/cashoutLocation";
import { THEME_SETTINGS } from "@theme-settings";
import { useFixBody } from "@state/hooks/shared";

export default observer(function CashoutConfirmation(props: {
	id: string;
	calculatedCashoutAmount: number;
	displayedAmount: string;
	onClose: () => void;
	onAccept: CashoutStore["cashout"];
	isSubmitting?: boolean;
	isLive: boolean;
	message?: string | null;
	cType: CashoutType;
	isOpen?: boolean;
	userId: string;
	liveBetSlipCountdown: number | null;
}) {
	useFixBody(true, props.isOpen);
	const { t } = useTranslation();

	const [acceptChangeRef, setAcceptChangeRef] =
		useState<HTMLInputElement | null>();

	return (
		<Modal>
			<div className="popup">
				<div className="popup__card">
					<div className="popup__header">
						{t("mybets:CASHOUT.TITLE")}
					</div>
					<div className="popup__body">
						{props.message != undefined ? (
							<div className="message--base message--warning">
								{props.message}
							</div>
						) : (
							<div>
								{t("mybets:CASHOUT.MESSAGE", {
									amount: props.displayedAmount,
									currency: ISOToDisplayCode(
										THEME_SETTINGS.defaultCurrency
									),
								})}
							</div>
						)}
						<div className="input--check u-mar--top--xsml">
							<input
								id="isChangeAccepted"
								className="input--check__box"
								ref={(newRef) => setAcceptChangeRef(newRef)}
								disabled={props.isSubmitting}
								type="checkbox"
							/>
							<label
								htmlFor="isChangeAccepted"
								className="input--check__label"
							>
								{t("mybets:CASHOUT.ACCEPT_CHANGED_AMOUNT")}
							</label>
						</div>
					</div>
					<div className="popup__footer">
						<button
							className="popup__btn btn btn--med btn--primary--inverted"
							disabled={props.isSubmitting}
							onClick={props.onClose}
							type="button"
						>
							{t("COMMON.CANCEL")}
						</button>
						<Button
							className="popup__btn btn btn--med btn--cashout"
							disabled={props.isSubmitting}
							onClick={() =>
								props.onAccept(
									{
										id: props.id,
										calculatedCashoutAmount:
											props.calculatedCashoutAmount,
										cType: props.cType,
										isChangeAccepted:
											acceptChangeRef?.checked || false,
										isLive: props.isLive,
										displayedAmount: props.displayedAmount,
										userId: props.userId,
										liveBetSlipCountdown:
											props.liveBetSlipCountdown,
									},
									CashoutLocation.OFFER
								)
							}
							type="submit"
							btnText={t("mybets:CASHOUT.TITLE")}
						></Button>
					</div>
				</div>
			</div>
		</Modal>
	);
});
